// extracted by mini-css-extract-plugin
export var dividerLine = "_7y-3";
export var itemImage = "_7y-9";
export var lightDivider = "_7y-4";
export var modalContent = "_7y-5";
export var modalContentCompact = "_7y-6";
export var productCard = "_7y-a";
export var productImage = "_7y-b";
export var productImageCompact = "_7y-7";
export var productImagePlaceholder = "_7y-c";
export var productImagePlaceholderCompact = "_7y-8";
export var progressBarBackground = "_7y-1";
export var progressBarContainer = "_7y-0";
export var progressBarFill = "_7y-2";